import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import Popover from '@material-ui/core/Popover';
import TableCell from '@material-ui/core/TableCell';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Link } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  Tooltip,
  CircularProgress,
  useTheme,
  Typography,
} from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import PopOver from '../../ModalNotify/index';
import KenButton from '../../../components/KenButton';
import SearchBox from '../../../components/SearchBox';
import FilterIcon from '../../../assets/icons/Filter.svg';

import { overridings as lightTheme } from '../../../themes/light-theme';
import KenSnackbar from '../../../components/KenSnackbar';

const useStyles = makeStyles((theme) => ({
  //Filter Icon
  filterIcon: {
    height: '12px',
    width: '12px',
    margin: '3px 0px -3px 5px',
  },
  //Filter Dropdown
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },

  // Search
  SearchBoxContainer: {
    float: 'right',
    position: 'absolute',
    top: '13px',
    right: '14px',
    // width: '136px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  // Table
  tableCaption: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.white,
    // color: theme.palette.KenColors.neutral100,
  },
}));

const UpcomingProgramsDataTable = (props) => {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);
  const [initialTableData, setInitialTableData] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const [filterState, setFilterState] = useState({});
  const { loading } = props;

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const theme = useTheme();

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason, submitted) => {
    setOpen(false);

    // if(["escapeKeyDown", "backdropClick"].includes(reason))
    //     handleSnackbarOpen('error', 'Please provide details to get notified.');
  };

  const tableTheme = createMuiTheme({
    ...lightTheme,
    overrides: {
      MuiTable: {
        root: {
          borderSpacing: '0px 5px',
          borderCollapse: 'separate',
        },
      },
      MuiToolbar: {
        root: {
          textAlign: 'left',
          backgroundColor: 'black',
          // backgroundColor: "#f69e22",
          // backgroundColor: "#061956",
          // color: 'white'
        },
      },
      MUIDataTableHeadCell: {
        sortAction: {
          alignItems: 'center',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        sortActive: {
          color: theme.palette.KenColors.neutral900,
        },
        root: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        fixedHeader: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
          padding: '12px',
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: 'none',
          padding: '2px 10px',
        },
        head: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
      },
      MuiTablePagination: {
        toolbar: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
        },
      },
      MuiPaper: {
        elevation4: {
          boxShadow: 'none',
        },
        rounded: {
          backgroundColor: theme.palette.KenColors.neutral20,
        },
      },
      MuiTableRow: {
        root: {
          backgroundColor: theme.palette.KenColors.white,
        },
        footer: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
        },
      },
      MUIDataTableHeadRow: {
        root: {
          backgroundColor: theme.palette.KenColors.neutralGray10,
        },
      },
      MUIDataTableBodyRow: {
        stackedParent: {
          padding: '0px',
        },
      },
    },
  });

  useEffect(() => {
    //console.log('Data Table: ', props.data);
    setTableData(props.data);
    setInitialTableData(props.data);
  }, [props]);

  const columns = [
    {
      name: 'Id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'InstituteId',
      label: 'INSTITUTE ID',
      options: {
        display: false,
      },
    },
    {
      name: 'Institute',
      label: 'INSTITUTE',

      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'Department',
      label: 'DEPARTMENT',
      options: {
        filter: true,
        sort: true,
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'academicprogram',
      label: 'ACADEMIC PROGRAM',
      options: {
        filter: true,
        sort: true,
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'type',
      label: 'TYPE',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Typography style={{ fontSize: '12px', fontWeight: '400' }}>
                {value || 'UG'}
              </Typography>
            </div>
          );
        },
        customHeadRender: ({ index, ...column }) =>
          setCustomColumnHeader(index, column),
      },
    },
    {
      name: 'StartDate',
      label: 'START DATE',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'EndDate',
      label: 'END DATE',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Apply',
      label: 'APPLY',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const programID = tableMeta.rowData[0];
          const programName = tableMeta.rowData[4];
          const InstituteId = tableMeta.rowData[1];

          return (
            <div>
              <KenButton variant='secondary' onClick={handleOpen}>
                Notify Me
              </KenButton>
            </div>
          );
        },
      },
    },
  ];

  const searchTableHandler = (event) => {
    let searchString = event.target.value;

    let columns = [...initialTableData];
    let searchResult = columns.filter((column) => {
      return (
        column.Institute.toLowerCase().includes(searchString.toLowerCase()) ||
        column.Department.toLowerCase().includes(searchString.toLowerCase()) ||
        column.academicprogram
          .toLowerCase()
          .includes(searchString.toLowerCase())
      );
    });

    setTableData(searchResult);
  };

  const title = (
    <Typography className={classes.tableCaption}>
      UPCOMING APPLICATIONS
    </Typography>
  );

  const muiDatatableOptions = {
    selectableRows: 'none',
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    search: false,
    rowsPerPage: 5,
    expandableRowsHeader: true,
    rowsPerPageOptions: [5, 10, 20, 30],
    customToolbar: () => {
      return (
        <div className={classes.SearchBoxContainer}>
          <SearchBox searchHandler={searchTableHandler} />
        </div>
      );
    },
    textLabels: {
      body: {
        noMatch: loading ? 'Fetching Data...' : 'No Matching Data',
        toolTip: 'Sort',
      },
    },
    sortOrder: {
      name: 'Institute',
      direction: 'asc',
    },
  };

  const setCustomColumnHeader = (index, column) => {
    //console.log(column)
    const columnFilterData = getColumnFilterData(column.name);
    return (
      <>
        <PopupState variant='popover' popupId='demo-popup-popover'>
          {(popupState) => (
            <>
              <TableCell
                key={index}
                {...bindTrigger(popupState)}
                style={{ minWidth: '160px' }}
              >
                <Tooltip title='Filter' style={{ cursor: 'pointer' }}>
                  <span>
                    {column.label}
                    <img className={classes.filterIcon} src={FilterIcon} />
                  </span>
                </Tooltip>
              </TableCell>

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <div className={classes.root}>
                  <FormControl
                    component='fieldset'
                    className={classes.formControl}
                  >
                    <FormLabel component='legend'>{column.label}</FormLabel>
                    <FormGroup>
                      {columnFilterData.map((option, index) => {
                        //console.log('option: ', option);
                        //console.log('filterState: ', filterState);

                        return (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={
                                  (filterState[column.name] || {})[
                                    option.value
                                  ] || false
                                }
                                onChange={(event) =>
                                  columnFilterHandler(event, column.name)
                                }
                                name={option.value}
                                color='primary'
                              />
                            }
                            label={option.label}
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </div>
              </Popover>
            </>
          )}
        </PopupState>
      </>
    );
  };

  // get the column filter options
  const getColumnFilterData = (columnName) => {
    const columnFilterOptions = [];

    const uniqueOptions = new Map();

    initialTableData.map((data) => {
      if (!uniqueOptions.has(data[columnName])) {
        uniqueOptions.set(data[columnName], true);

        columnFilterOptions.push({
          label: data[columnName] || '',
          value: data[columnName] || '',
        });
      }
    });
    //console.log('columnFilterOptions: ', columnFilterOptions);

    return columnFilterOptions;
  };

  // filter function for columns
  const columnFilterHandler = (event, columnName) => {
    const filterString = event.target.name;
    setFilterValue(filterString);
    //console.log('filter string: ', filterString);
    //console.log('columnName: ', columnName);

    // set filter state
    let columnState = { ...filterState[columnName] };
    columnState = { ...columnState, [event.target.name]: event.target.checked };
    setFilterState({ ...filterState, [columnName]: columnState });
    //console.log('columnState: ', columnState);

    const searchStrings = Object.keys(columnState).filter(
      (k) => columnState[k] === true
    );
    //console.log('searchStrings: ', searchStrings);

    if (searchStrings.length > 0) {
      const filterResult = initialTableData.filter((data) => {
        //console.log('data[columnName]): ', data[columnName]);
        return searchStrings.indexOf(data[columnName] || '') !== -1;
      });

      // set table data
      setTableData(filterResult);
    } else {
      // set table data
      setTableData(initialTableData);
    }

    //filteration logic
    /*let filterResult = initialTableData.filter((data) => {
            return data[columnName] === null ? ""
                : data[columnName].toLowerCase().includes(filterString.toLowerCase())
        });*/
    //console.log('filterResult', filterResult);
  };

  return (
    <div style={{ position: 'relative', marginTop: 20 }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 110,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255,0.8)',
          }}
        >
          <CircularProgress size={24} />
        </div>
      )}
      <PopOver
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
        notify={true}
        handleSnackbarOpen={handleSnackbarOpen}
      />

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position='Bottom-Right'
      />

      <MuiThemeProvider theme={tableTheme}>
        <MUIDataTable
          title={title}
          data={tableData}
          columns={columns}
          options={muiDatatableOptions}
        />
      </MuiThemeProvider>
    </div>
  );
};

export default UpcomingProgramsDataTable;
